import { render, staticRenderFns } from "./miniStats.vue?vue&type=template&id=8a419dd0&scoped=true&"
import script from "./miniStats.vue?vue&type=script&lang=js&"
export * from "./miniStats.vue?vue&type=script&lang=js&"
import style0 from "./miniStats.vue?vue&type=style&index=0&id=8a419dd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a419dd0",
  null
  
)

export default component.exports